module.exports = __webpack_public_path__ + "static/img/Taiwan_03.08165366.jpg";